import { EL_TRAIT } from '../lib/rules.js';

export const EL_COLOR = { 목: '#5aa86a', 화: '#e0574a', 토: '#c9a227', 금: '#8a8f9a', 수: '#3f6db5' };
export function Dots({ n }) {
  return <span className="dots" aria-label={`상성 ${n}/5`}>{[1, 2, 3, 4, 5].map((i) => <i key={i} className={i <= n ? 'on' : ''} />)}</span>;
}
export function ElIcon({ el }) {
  return <span className="elicon" style={{ background: EL_COLOR[el] }} title={`${el} · ${EL_TRAIT[el]}`}>{el}</span>;
}
